// $(document).ready(function () {
  

// //   $(document).on("click mouseup", ".boost-pfs-quickview-cart .boost-pfs-quickview-cart-btn .boost-pfs-quickview-cart-btn-text", function(event){
// //       event.preventDefault(); 
// //       console.log("Testing demo");
// //       location.reload();
// //   });

// //   $(document).on("click touch", ".boost-pfs-quickview-cart .boost-pfs-quickview-cart-btn .boost-pfs-quickview-cart-btn-text", function(event){
// //       event.preventDefault(); 
// //       console.log("Testing demo");
// //       location.reload();
// //   });

//   // var myElement = document.getElementByClassName('.boost-pfs-quickview-cart .boost-pfs-quickview-cart-btn .boost-pfs-quickview-cart-btn-text');
//   // var hammer = new Hammer(myElement);
  
//   // hammer.on('tap', function(event) {
//   //     console.log("Tap event");
//   //     location.reload();
//   // });
  
// //   $(document).on('click','.boost-pfs-addtocart-wrapper button[aria-label="Ajouter au panier"]', function() {
// //       setTimeout(function() {
// //           window.location.reload();
// //       }, 2000);
// //   }); 

// //   $(document).on('click', '.boost-pfs-quickview-cart .boost-pfs-quickview-cart-btn', function() {
// //       // Use setTimeout to reload the page again after a delay (in this case, 1000 milliseconds or 1 second)
// //       setTimeout(function() {
// //           reloadfunc();
// //       }, 1000);
// //   });

//   function reloadfunc () {
//       location.reload(true);
//   }
  
//   $(document).on('click', 'button.btn.btn--full.add-to-cart.btn--secondary', function () {
//     $('.main-content').addClass('remove');
//   });

//   jQuery('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').click(function(){
//       $('.main-content').addClass('remove');
//   });

//   $(document).on('click', '.remove', function () {
//     console.log('it`s working or not, please check');
//     $('.main-content').removeClass('remove');
//     location.reload();
//   });

//    $(".drawer__close-button.js-drawer-close").click(function(){
//        $('.main-content').removeClass("remove");
//         location.reload(true);
//     });
  
// });



// jQuery(document).ready(function() {

//     $(".add-to-cart").click(function(){
//         $("body").addClass("custom-remove");
//     });

//    $('.contact-submit').click(function() {
//       var email = $('.email-verification').val();
//       if (/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(email)) {
//           // Valid Gmail address, continue with form submission
//           return true; // Allow form submission
//       } else {
//           // Invalid email address, prevent form submission
//           alert('Veuillez renseigner une adresse email valide.');
//           event.preventDefault(); // Prevent the form from being submitted
//           return false;
//       }
//   });

//   $(".percent-with-price:not(:first)").hide();
//   $(".variant-input").click(function() {

//     // Get the index of the clicked element
//     var index = $(this).index();

//     // Hide all the spans with the "toggle-span" class
//     $(".percent-with-price").hide();

//     // Show the span at the clicked index
//     $(".percent-with-price:eq(" + index + ")").show();
    
//   });
  
//   jQuery('.product-remove-content:contains("- 1 objets restants")').each(function(){
//       jQuery(this).html(jQuery(this).html().split("- 1 objets restants").join(""));
//   });
  
//   function removeCommas(text) {
//     // Replace commas with an empty string
//     return text.replace(/,/g, ' ');
//   }

//   // Loop through product prices and remove commas
//   jQuery('.boost-pfs-filter-product-item-regular-price').each(function() {
//     var originalText = jQuery(this).text();
//     var cleanedText = removeCommas(originalText);
//     console.log('cleanedText',cleanedText);
//     jQuery(this).text(cleanedText);
//   });
  
//   $('.tabs-stage div').hide();
//   $('.tabs-stage div:first').show();
//   $('.nav-dots li:first').addClass('tab-active');
  
//   $('.nav-dots a').on('click', function(event){
//     event.preventDefault();
//     $('.nav-dots li').removeClass('tab-active');
//     $(this).parent().addClass('tab-active');
//     $('.tabs-stage div').hide();
//     $($(this).attr('href')).show();
//   });

//   // Close the popup when the "Close" button is clicked
//   jQuery("#close-popup").click(function(){
//       jQuery('.popup').css("display", "block");
//   }); 
  
//   setTimeout(function () {
//      jQuery(".boost-pfs-filter-product-item-label .promo-text-code").text("Promo");
//    }, 1000);

  
// });  




function loadRelatedProducts(productId) {
  fetch(`/recommendations/products.json?product_id=${productId}&limit=4`)
    .then(res => res.json())
    .then(data => {
      const container = document.getElementById('cart-related-products');
      container.innerHTML = ''; // Clear previous

      if (data.products.length > 0) {
        // Build Swiper structure
        container.innerHTML = `
        <div class="related-swiper-main">
          <h3>Produits associés</h3>
        
          <div class="swiper related-swiper">
            <div class="swiper-wrapper">
              ${data.products
                .map(product => `
                  <div class="swiper-slide related-product">
                    <div class="relad-iner">
                        <a href="${product.url}" class="product-link">
                           <img src="${product.featured_image}" alt="${product.title}" />
                        </a>
                        <div class="relt-info">
                            <p class="product-title">${product.title}</p>
                            <p class="product-price">${theme.Currency.formatMoney(product.price)} </p>
                            <div class="add-related-to-cart btn" data-variant-id="${product.variants[0].id}"> Add</div>
                        </div>
                       
                      
                    </div>  
                  </div>
                `)
                .join('')}
            </div>
            <!-- Swiper Navigation -->
          </div>
        <div class="swiper-button-next">
           <svg role="presentation" focusable="false" width="5" height="8" class=" icon-chevron-right-small reverse-icon" viewBox="0 0 5 8">
            <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </div>
        <div class="swiper-button-prev">
          <svg role="presentation" focusable="false" width="5" height="8" class=" icon-chevron-left-small reverse-icon" viewBox="0 0 5 8">
            <path d="m4.25 7-3-3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </div>
      </div>
        `;

        // Initialize Swiper
        new Swiper('.related-swiper', {
          slidesPerView: 1.2,
          spaceBetween: 15,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 1.3,
              spaceBetween: 15
            },
            1024: {
              slidesPerView: 1.3,
              spaceBetween: 15
            }
          }
        });

        // Handle Add to Cart clicks
        container.querySelectorAll('.add-related-to-cart').forEach(button => {
          button.addEventListener('click', function () {
            const variantId = this.getAttribute('data-variant-id');

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
              .then(res => res.json())
              .then(() => {
                 document.dispatchEvent(new CustomEvent('cart:open'));
                 document.dispatchEvent(new CustomEvent('cart:build'));
              })
              .catch(err => console.error('Error adding product:', err));
          });
        });


      }
    })
    .catch(err => console.error('Error loading related products:', err));
}

document.addEventListener('ajaxProduct:added', function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.items.length > 0) {
        // Get first product's ID
        loadRelatedProducts(cart.items[0].product_id);
      }
    });
});

document.addEventListener('cart:build', function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.items.length > 0) {
        // Get first product's ID
        loadRelatedProducts(cart.items[0].product_id);
      }
    });
});


document.addEventListener("DOMContentLoaded", () => {
   fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.items.length > 0) {
        // Get first product's ID
        loadRelatedProducts(cart.items[0].product_id);
      }
    });

});


setTimeout(function() {

const parfumdiv = document.querySelectorAll('.parfumcustomdata');

if (parfumdiv.length > 0) {

   console.log("div found");
    parfumdiv.forEach(function(el) {
        if (el.textContent.trim() !== '') {
            el.parentElement.classList.add('parfum-prod');
        }
    });
}

}, 2000); 




// document.addEventListener("DOMContentLoaded", () => {

//  new Swiper('.free-product-slider', {
//     slidesPerView: 1.2,
//     spaceBetween: 15,
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//     breakpoints: {
//       768: {
//         slidesPerView: 1.3,
//         spaceBetween: 15
//       },
//       1024: {
//         slidesPerView: 1.3,
//         spaceBetween: 15
//       }
//     }
//   });

// });